import React, { useEffect } from 'react';

import DialogLoader from '../../../../components/transitions/DialogLoader/DialogLoader';
import { useAuthorize } from '../hooks/useAuthorize';
import { ComponentsWrapper } from '../layout/layout';

export const Authorize = ({ isTokenExpired = false }: { isTokenExpired?: boolean }) => {
  const { getAuthorizeFallbackUrl, getAuthorizeUrl } = useAuthorize();

  useEffect(() => {
    let isActive = true;

    const redirectToAuthorize = async () => {
      let authorizeURL: string | null;

      try {
        authorizeURL = await getAuthorizeUrl(isTokenExpired);
      } catch {
        authorizeURL = getAuthorizeFallbackUrl(isTokenExpired);
      }

      if (isActive && authorizeURL) {
        window?.location?.replace(authorizeURL);
      }
    };

    redirectToAuthorize();

    return () => {
      isActive = false;
    };
  }, [getAuthorizeFallbackUrl, getAuthorizeUrl, isTokenExpired]);

  return (
    <ComponentsWrapper>
      <DialogLoader />
    </ComponentsWrapper>
  );
};
